import { AdminSideBar } from "components";
import { useLocation } from "react-router-dom";

type Props = {
    children: React.ReactNode;
}
export default function AdminLayout({ children }: Props) {
    const location = useLocation();
    const isAuthPage = location.pathname.startsWith("/admin/login");

    if (isAuthPage) {
        return <>{children}</>;
    }

    return (
        <div className="flex h-screen overflow-hidden">
            <AdminSideBar />
            <div className="flex-1 overflow-y-auto bg-achromatic-50">
                {children}
            </div>
        </div>
    );
}